module.exports = __webpack_public_path__ + "img/pattern1 blue copy.f304d31d.svg";